import { AbstractControl, FormControl, Validators } from '@angular/forms';
import {
  AlarmRuleComparisonRuleConfig,
  AlarmRuleConditionType,
  ComparisonOperator,
  ComparisonValueSourceType,
} from '../../../../../../../types/dtos/alarm-rule-condition.dto';
import { AlarmRuleComparisonRuleFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleCondition } from '../base-rule-condition';
import { ComparisonCondition } from './comparison-condition';

export class ComparisonRuleCondition extends BaseRuleCondition {
  public getDescription(): string {
    return 'common.alarm-rule.condition.comparison.description';
  }

  public getIcon(): string {
    return 'compare';
  }

  public getName(): string {
    return 'common.alarm-rule.condition.comparison.title';
  }

  public getType(): AlarmRuleConditionType {
    return AlarmRuleConditionType.COMPARISON;
  }

  public getEditorComponent(): any {
    return ComparisonCondition;
  }

  public override configToFrom(data: AlarmRuleComparisonRuleConfig): Record<string, unknown> {
    return {
      ruleOperator: data.operator ?? 'gt',

      left_source_type: data.left?.source_type ?? 'current_value',
      left_measurement_variable: data.left?.measurement_variable ?? null,
      left_fixed_value: data.left?.fixed_value ?? null,
      left_range_hours: data.left?.range_hours ?? null,
      left_value_count: data.left?.value_count ?? null,

      right_source_type: data.right?.source_type ?? 'fixed_value',
      right_measurement_variable: data.right?.measurement_variable ?? null,
      right_fixed_value: data.right?.fixed_value ?? null,
      right_range_hours: data.right?.range_hours ?? null,
      right_value_count: data.right?.value_count ?? null,
    };
  }

  public formToConfig(form: AlarmRuleComparisonRuleFormDto): AlarmRuleComparisonRuleConfig {
    return {
      operator: form.ruleOperator ?? 'gt',

      left: {
        source_type: form.left_source_type ?? 'current_value',
        measurement_variable: form.left_measurement_variable ?? undefined,
        fixed_value: Number(form.left_fixed_value),
        range_hours: Number(form.left_range_hours),
        value_count: Number(form.left_value_count),
      },

      right: {
        source_type: form.right_source_type ?? 'fixed_value',
        measurement_variable: form.right_measurement_variable ?? undefined,
        fixed_value: Number(form.right_fixed_value),
        range_hours: Number(form.right_range_hours),
        value_count: Number(form.right_value_count),
      },
    } as AlarmRuleComparisonRuleConfig;
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      ruleOperator: new FormControl<ComparisonOperator | null>('gt', {
        validators: [Validators.required],
        nonNullable: false,
      }),

      left_source_type: new FormControl<ComparisonValueSourceType | null>(ComparisonValueSourceType.CURRENT_VALUE, {
        validators: [Validators.required],
        nonNullable: false,
      }),
      left_measurement_variable: new FormControl<string | null>(null),
      left_fixed_value: new FormControl<number | null>(null),
      left_range_hours: new FormControl<number | null>(null),
      left_value_count: new FormControl<number | null>(null),

      right_source_type: new FormControl<ComparisonValueSourceType | null>(ComparisonValueSourceType.FIXED_VALUE, {
        validators: [Validators.required],
        nonNullable: false,
      }),
      right_measurement_variable: new FormControl<string | null>(null),
      right_fixed_value: new FormControl<number | null>(null),
      right_range_hours: new FormControl<number | null>(null),
      right_value_count: new FormControl<number | null>(null),
    };
  }
}